<template>
  <div class="text-start">
    <label
      :for="id"
      class="form-label fw-bold mb-2"
      :class="{ 'visually-hidden': hideLabel }"
    >
      <div>{{ content }}</div>
    </label>
    <div v-if="description.length > 0" class="mb-1">
      <small>{{ description }}</small>
    </div>

    <div v-if="subtype === 'text' || subtype === 'number'">
      <input
        class="form-control shadow-sm"
        :class="{
          'border-danger': isSubmitted && !isCorrect && !openAnswer,
          'border-success': isCorrect
        }"
        :type="subtype"
        :min="min"
        :max="max"
        :id="id"
        :placeholder="placeholder"
        autocomplete="off"
        v-model="formValue"
        :disabled="isCorrect || isReport"
        @change="updateFormValue"
      />
    </div>

    <!-- Text area -->
    <div v-else>
      <textarea
        class="form-control shadow-sm"
        :id="id"
        :placeholder="placeholder"
        rows="4"
        v-model="formValue"
        @change="updateFormValue"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormInput",
  components: {},
  data() {
    return {
      formValue: ""
    };
  },
  props: {
    isCorrect: {
      type: Boolean,
      default: false
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "formInput"
    },
    content: {
      type: String,
      default: "Form Text Input Content"
    },
    openAnswer: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ""
    },
    subtype: {
      type: String,
      default: "text"
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    formInputValue: {
      type: [String, Number],
      default: ""
    },
    isReport: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ["updateFormValue"],
  computed: {
    isFieldComplete() {
      if (this.subtype === "text" || this.subtype === "textarea") {
        return this.formValue.trim().length > 0;
      } else if (this.subtype === "number") {
        return this.formValue !== "" && !isNaN(this.formValue);
      }
      return false;
    }
  },
  methods: {
    updateFormValue() {
      // Emit only if the value has changed to avoid unnecessary updates
      if (this.formInputValue !== this.formValue) {
        this.$emit("updateFormValue", this.formValue);
      }
    }
  },
  mounted() {
    // Help with rendering form conditionally (e.g., when editing objectives)
    if (this.formInputValue !== undefined) {
      this.formValue = this.formInputValue;
    }
  },
  watch: {
    formInputValue(newValue) {
      this.formValue = newValue;
    },
    formValue(newValue) {
      if (
        this.max !== null &&
        this.subtype === "number" &&
        newValue > this.max
      ) {
        this.formValue = this.max;
      }
      if (
        this.min !== null &&
        this.subtype === "number" &&
        newValue < this.min
      ) {
        this.formValue = this.min;
      }
    }
  }
  /* lifecycle hooks */
};
</script>
